import { render, staticRenderFns } from "./DeleteCampaignButton.vue?vue&type=template&id=228051a9&scoped=true&"
import script from "./DeleteCampaignButton.vue?vue&type=script&lang=js&"
export * from "./DeleteCampaignButton.vue?vue&type=script&lang=js&"
import style0 from "./DeleteCampaignButton.vue?vue&type=style&index=0&id=228051a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228051a9",
  null
  
)

/* custom blocks */
import block0 from "./DeleteCampaignButton.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports